import React, { useContext } from 'react';

import { desktopOnly } from 'styles/mixins/displayMobileDesktop';
import { CtaButton } from 'components/global/CtaButton';
import { trackEvent } from 'utils/metricsTracking';
import { navExternalWithQueryString } from 'utils/marketingSafeDomain';
import { EVENTS } from 'consts/metricsTrackingEvents';

import {
  HeaderContainer,
  Subtitle,
  Title,
  TitleContainer,
  buttonStyles,
} from './SubsectionHeader.style';
import { ModuleNameContext } from './ModuleNameContext';
import { type SubsectionProps } from '../Subsection';

export const SubsectionHeader = ({ content }: { content: SubsectionProps }) => {
  const { title, subtitle, ctaButtonText, ctaECommerceLink } = content;
  const moduleName = useContext(ModuleNameContext);

  const handleECommerceClick = (event: React.SyntheticEvent) => {
    event.preventDefault();
    trackEvent(EVENTS.ctaClicked, { module: moduleName });
    navExternalWithQueryString(ctaECommerceLink);
  };

  return (
    <HeaderContainer>
      <TitleContainer>
        {title && <Title>{title}</Title>}
        {subtitle && <Subtitle>{subtitle}</Subtitle>}
      </TitleContainer>
      {ctaButtonText && (
        <CtaButton
          buttonText={ctaButtonText}
          module={moduleName}
          css={[buttonStyles, desktopOnly()]}
          {...(ctaECommerceLink && {
            onClick: handleECommerceClick,
          })}
        />
      )}
    </HeaderContainer>
  );
};
